import Loader from 'umg-ember-backend/components/ui/loader';
import Window from 'umg-ember-backend/components/ui/window';

<template>
  <Window>
    <:body>
      <Loader @isWaiting={{true}} />
    </:body>
  </Window>
</template>
